import React, { Component } from 'react';
import classnames from 'classnames';
import './styles/Nav.scss'

import logo from '../../assets/images/logo-circle.svg';
import facebook from '../Footer/assets/facebook.svg';
import twitter from '../Footer/assets/twitter.svg';
import instagram from '../Footer/assets/instagram.svg';
import youtube from '../Footer/assets/youtube.svg';

class Nav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };

    this.el = React.createRef();
    this.toggle = this.toggle.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (this.el.current.contains(e.target)) {
      return;
    }

    this.setState({
      open: false
    });
  }

  toggle() {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { open } = this.state;
    const navClass = classnames('Nav', {
      'Nav--open': open
    });

    return (
      <div className={navClass} ref={this.el}>
        <div className="Nav-menuButton">
          <span onClick={this.toggle}>{ open ? 'Close' : 'Menu' }</span>
        </div>
        
        <a href="#">
          <img src={logo} alt="Uninterrupted" className="Nav-logo" />
        </a>

        <div className="Nav-searchButton">
          <a href="#">Search</a>
        </div>
        
        <div className="Nav-content">
          <div className="Nav-content-menu">
            <div className="Nav-content-menu-col">
              <ul>
                <li><a href="/">Originals</a></li>
                <li><a href="/">Podcasts</a></li>
                <li><a href="/">Documentaries</a></li>
                <li><a href="/">Series</a></li>
              </ul>
            </div>
            <div className="Nav-content-menu-col">
              <ul>
                <li><a href="/">About us</a></li>
                <li><a href="/">Careers</a></li>
                <li><a href="/">Contact</a></li>
                <li className="Nav-social">
                  <a href="https://facebook.com/Uninterrupted/"><img src={facebook} alt=""/></a>
                  <a href="https://twitter.com/uninterrupted"><img src={twitter} alt=""/></a>
                  <a href="https://instagram.com/uninterrupted"><img src={instagram} alt=""/></a>
                  <a href="https://youtube.com/uninterrupted"><img src={youtube} alt=""/></a>
                </li>
              </ul>
            </div>
          </div>

          <div className="Nav-content-signup">
            <input type="text" placeholder="Sign up for news" />
            <button>Go</button>
          </div>
        </div>

      </div>
    )
  }
}

export default Nav;